import React, { useEffect, useState } from 'react';
import './ConfirmDialog.css';

// In-app replacement for window.confirm. Native confirm dialogs can be
// suppressed by browsers/webviews (observed in the wild — the admin
// delete-user dialog never appeared), which silently strips confirmation
// from destructive actions. This renders a real DOM modal instead.
//
// Usage: `if (!(await confirmDialog('Delete X?\n\nCannot be undone.'))) return;`
// Requires <ConfirmDialogHost /> mounted once (App.js).

let showFn = null;

export function confirmDialog(message, { confirmLabel = 'Confirm', danger = true } = {}) {
  if (!showFn) return Promise.resolve(window.confirm(message));
  return showFn({ message, confirmLabel, danger });
}

export function ConfirmDialogHost() {
  const [req, setReq] = useState(null); // { message, confirmLabel, danger, resolve }

  useEffect(() => {
    showFn = (opts) => new Promise((resolve) => setReq({ ...opts, resolve }));
    return () => { showFn = null; };
  }, []);

  useEffect(() => {
    if (!req) return;
    const onKey = (e) => {
      if (e.key === 'Escape') { req.resolve(false); setReq(null); }
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [req]);

  if (!req) return null;

  const close = (answer) => { req.resolve(answer); setReq(null); };

  return (
    <div className="cdlg-overlay" onClick={() => close(false)}>
      <div className="cdlg-box" role="dialog" aria-modal="true" onClick={(e) => e.stopPropagation()}>
        <div className="cdlg-kicker">◆ CONFIRM</div>
        <div className="cdlg-message">{req.message}</div>
        <div className="cdlg-actions">
          <button className="cdlg-btn cdlg-btn-cancel" autoFocus onClick={() => close(false)}>Cancel</button>
          <button
            className={`cdlg-btn ${req.danger ? 'cdlg-btn-danger' : 'cdlg-btn-primary'}`}
            onClick={() => close(true)}
          >
            {req.confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
